<template>
  <div class="content">
    <SettingPasswordChange>
    </SettingPasswordChange>
  </div>
</template>

<script>
  import SettingPasswordChange from './SettingPasswordChange.vue'
  
  export default {
    components: {
      SettingPasswordChange
    },
    data () {
      return {
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Setting.vue